import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.clarityId) {
  (function (c: Window, l: Document, a: string, r: string, i: string) {
    const w = c as unknown as Record<string, { q?: unknown[] } & (() => void)>;
    w[a] =
      w[a] ||
      function (this: unknown) {
        (w[a].q = w[a].q || []).push(arguments);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y?.parentNode?.insertBefore(t, y);
  })(window, document, 'clarity', 'script', environment.clarityId);
}

if (environment.gaId) {
  const w = window as unknown as {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gaId;
  document.head.appendChild(s);

  w.dataLayer = w.dataLayer || [];
  w.gtag = (...args: unknown[]) => {
    (w.dataLayer = w.dataLayer || []).push(args);
  };
  w.gtag('js', new Date());
  w.gtag('config', environment.gaId);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
